import LoadingSpinner from "./Spinner";

const Loading = () => {
  return (
    <div className="flex w-full justify-center items-center min-h-screen bg-slate-950">
      <LoadingSpinner></LoadingSpinner>
    </div>
  );
};

export default Loading;
